export const PAGE_NAME = "verification-page";
